import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import Avatar from "react-avatar";
import { Button, Modal } from "../components/Modal";

interface RelatedUsersModalProps {
    isOpen: boolean;
    metadataKey: string;
    metadataValue: string;
    users: any[];
    onClose: () => void;
    onSelectUser: (user: any) => void;
}

export const RelatedUsersModal = ({ isOpen, metadataKey, metadataValue, users, onClose, onSelectUser }: RelatedUsersModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose} title={`Related Users · ${metadataKey}: ${metadataValue}`} icon={["fad", "users"]} iconColor="text-blue-600" size="lg">
        <div className="p-6 max-h-[70vh] overflow-y-auto">
            {users.length === 0 ? (
                <div className="text-center py-8 text-sm text-gray-500">No users found with {metadataKey} = “{metadataValue}”.</div>
            ) : (
                <div className="space-y-2">
                    {users.map((user) => (
                        <button key={user.id} type="button" onClick={() => onSelectUser(user)} className="w-full flex items-center gap-3 border border-gray-200 rounded-lg p-3 text-left hover:bg-gray-50">
                            <Avatar name={user.fullName} src={user.photo} size="36px" round={true} />
                            <span className="min-w-0 flex-1">
                                <span className="block text-sm font-medium text-gray-900">{user.fullName || user.email}</span>
                                <span className="block text-xs text-gray-500 truncate">{user.email}</span>
                            </span>
                            <FontAwesomeIcon icon={["fad", "chevron-right"]} className="w-3 h-3 text-gray-400" />
                        </button>
                    ))}
                </div>
            )}
        </div>
        <div className="border-t border-gray-200 bg-gray-50 px-6 py-4 flex justify-end"><Button variant="secondary" onClick={onClose}>Close</Button></div>
    </Modal>
);
